var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9 40.9h-3.6v-2.1h9.8v2.1h-3.6V50h-2.6v-9.1zm12.8 9.3a6.2 6.2 0 01-5.3-2.9 6.1 6.1 0 010-6c.5-.9 1.3-1.6 2.2-2.1a6.5 6.5 0 016.2 0c.9.5 1.7 1.2 2.2 2.1s.8 1.9.8 3-.3 2.1-.8 3-1.3 1.6-2.2 2.1c-.9.5-1.9.8-3.1.8zm0-2.2c.7 0 1.3-.2 1.8-.5s1-.7 1.3-1.3.5-1.2.5-1.9-.2-1.3-.5-1.9-.7-1-1.3-1.3a3.5 3.5 0 00-3.6 0c-.5.3-1 .7-1.3 1.3s-.5 1.2-.5 1.9.2 1.3.5 1.9.7 1 1.3 1.3 1.2.5 1.8.5zm12.9-9.2c1 0 1.9.2 2.6.5s1.3.8 1.7 1.4c.4.6.6 1.3.6 2.2 0 .8-.2 1.5-.6 2.2a4 4 0 01-1.7 1.4c-.7.3-1.6.5-2.6.5h-2.3v3h-2.6V38.8h4.9zm-.1 6.1a3 3 0 001.8-.6c.4-.3.6-.8.6-1.4 0-.6-.2-1.1-.6-1.4s-1-.5-1.8-.5h-2.1v3.9h2.1zm-29.8 9.9h2.6v9.1H40V66h-8.2l-.1-11.2zm9.7 0H44V66h-2.6V54.8zm15.5 0V66h-2.1l-5.6-6.8V66h-2.6V54.8h2.1l5.6 6.8v-6.8h2.6zm11.4 9.1V66h-8.7V54.8H68v2.1h-5.9v2.4h5.2v2h-5.2v2.6h6.2z",
    fill: "#737e8c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 34h38.5",
    stroke: "#ff0089",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLineIcon);
export default __webpack_public_path__ + "static/media/TopLine-icon.0e3193b90c0af690ef2f732c4301ab37.svg";
export { ForwardRef as ReactComponent };